export default "__VITE_ASSET__DHGo5$a$__"